import { useCallback, useState } from "react";

export default function useGetBinderBasicsTemplatesData() {
  const [isLoadingBinderBasicsTemplate, setIsLoadingBinderBasicsTemplate] =
    useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchBinderBasics = useCallback(
    async (trustId: string, trustName: string) => {
      let url = `https://hometrustapi.azurewebsites.net/api/Templates/generate/BinderBasics/${trustId}`;

      setIsLoadingBinderBasicsTemplate(true);
      setError(null);

      // console.log("getting Templates");
      try {
        await fetch(
          url, 
          { 
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }, 
            method: "GET" 
          })
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${trustName}_Binder Basics.docx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          })
          .catch((error) => console.error("Error downloading file:", error));
      } catch (error: any) {
        setError(error);
        setIsLoadingBinderBasicsTemplate(false);
      }
    },
    []
  );

  return { isLoadingBinderBasicsTemplate, error, fetchBinderBasics };
}
